var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoosterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "7 2 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_618_7210)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.0001,
    cy: 22.9991,
    r: 17.2667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.0001,
    cy: 22.9991,
    r: 17.2667,
    stroke: "#E0CCFF"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9777 32.9123V25.9639H23.0951C22.5551 25.9639 22.1902 25.2925 22.4529 24.7387L27.8242 12.7048C28.1599 11.9159 29.1963 12.2012 29.1963 13.0908V20.1231H32.9036C33.4437 20.1231 33.794 20.7777 33.5605 21.3316L28.3643 33.2816C28.014 34.0872 26.9777 33.8019 26.9777 32.9123Z",
    fill: "url(#paint0_linear_618_7210)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49 23C49 34.598 39.598 44 28 44C16.402 44 7 34.598 7 23C7 11.402 16.402 2 28 2C39.598 2 49 11.402 49 23ZM11.2 23C11.2 32.2784 18.7216 39.8 28 39.8C37.2784 39.8 44.8 32.2784 44.8 23C44.8 13.7216 37.2784 6.2 28 6.2C18.7216 6.2 11.2 13.7216 11.2 23Z",
    fill: "url(#paint1_linear_618_7210)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_618_7210",
    x: 0.833398,
    y: 0.782422,
    width: 54.3334,
    height: 54.3332,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.95
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.95
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.427451 0 0 0 0 0.278431 0 0 0 0 0.988235 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_618_7210"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_618_7210",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_618_7210",
    x1: 24.1252,
    y1: 33.0759,
    x2: 39.1644,
    y2: 27.6915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#9116F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3199FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_618_7210",
    x1: 13.558,
    y1: 42.6723,
    x2: 56.6619,
    y2: 13.2111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DCB4FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4D2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoosterIcon);
export default __webpack_public_path__ + "static/media/booster-icon.66a621c0fcb314673930b578634a2719.svg";
export { ForwardRef as ReactComponent };